module.exports = __webpack_public_path__ + "static/ic_bg_assembly.e69481f1.svg";